import React, {useContext} from 'react'
import {Link} from 'react-router-dom'

import slider0 from '../assets/banner/promo_mama.jpg'
import slider1 from '../assets/banner/bannerHomeMarzo.jpg'
import slider2 from '../assets/banner/bannerDeporteMarzo.jpg'
import slider3 from '../assets/banner/bannerNew3.jpg'

import promo1 from '../assets/banner/tecno1.png'
import promo2 from '../assets/banner/mascota2.png'
import promo3 from '../assets/banner/casa3.png'

import back from '../assets/banner/fondo-banner-sup2.jpg'

import {ContextApp} from '../context/ContextApp'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

export default () => {
  const contextApp = useContext(ContextApp)
  const {
    paginate,
    categories,
    productsToShowInHome,
    getCategoryNameFromMenu,
    getProductsBySubCategory,
    cleanProductsBySubCategory,
    getProductsByCategory,
  } = contextApp

  const catMascotas = categories.filter(
    category => category.id === 39 && category.enabled == 1,
  )
  const catHogar = categories.filter(
    category => category.id === 62 && category.enabled == 1,
  )
  const catDeportes = categories.filter(
    category => category.id === 29 && category.enabled == 1,
  )

  const catTecno = categories.filter(
    category => category.id === 10 && category.enabled == 1,
  )

  const catCusca = categories.filter(
    category => category.id === 139 && category.enabled == 1,
  )

  if (productsToShowInHome.length === 0) {
    return null
  }

  return (
    <div class="row">
      {' '}
      <div class="col-xl pr-xl-2 mb-4 mb-xl-0">
        <div class="bg-img-hero mr-xl-1 height-410-xl max-width-1060-wd max-width-830-xl overflow-hidden">
          <div
            class="js-slick-carousel u-slick"
            data-autoplay="true"
            data-speed="7000"
            data-pagi-classes="text-center position-absolute right-0 bottom-0 left-0 u-slick__pagination u-slick__pagination--long justify-content-start ml-9 mb-3 mb-md-5"
          ></div>

          <OwlCarousel
            id="owl-main"
            items={1}
            autoplay={true}
            nav
            dots
            loop
            style={{position: 'initial'}}
          >
            <Link to='/productos/promocion-dia-de-las-madres/145'>
              <div
                class="item"
                style={{
                  backgroundImage: `url(${slider0})`,
                  backgroundRepeat: 'no-repeat',
                }}
              ></div>
            </Link>
            {catMascotas.map(category => (
              <Link
                to={`/product_list/${category.name}`}
                onClick={() => {
                  getProductsByCategory(
                    category.id,
                    category,
                    category.name,
                    paginate,
                    0,
                    0,
                    0,
                  )
                }}
              >
                <div
                  class="item"
                  style={{
                    backgroundImage: `url(${slider1})`,
                    backgroundRepeat: 'no-repeat',
                  }}
                ></div>
              </Link>
            ))}
            {catDeportes.map(category => (
              <Link
                to={`/product_list/${category.name}`}
                onClick={() => {
                  getProductsByCategory(
                    category.id,
                    category,
                    category.name,
                    paginate,
                    0,
                    0,
                    0,
                  )
                }}
              >
                <div
                  class="item"
                  style={{
                    backgroundImage: `url(${slider2})`,
                    backgroundRepeat: 'no-repeat',
                  }}
                ></div>
              </Link>
            ))}
            {catTecno.map(category => (
              <Link
                to={`/product_list/${category.name}`}
                onClick={() => {
                  getProductsByCategory(
                    category.id,
                    category,
                    category.name,
                    paginate,
                    0,
                    0,
                    0,
                  )
                }}
              >
                <div
                  class="item"
                  style={{
                    backgroundImage: `url(${slider3})`,
                    backgroundRepeat: 'no-repeat',
                  }}
                ></div>
              </Link>
            ))}
          </OwlCarousel>
        </div>
      </div>
      <div class="col-xl-auto pl-xl-2 ">
        <div class="overflow-hidden">
          <ul class="list-unstyled row flex-nowrap flex-xl-wrap overflow-auto overflow-lg-visble mx-n2 mx-xl-0 d-xl-block mb-0">
            <li class="px-2 px-xl-0 flex-shrink-0 flex-xl-shrink-1 mb-3">
              <Link class="min-height-126 max-width-320 py-1 py-xl-2 py-wd-1 banner-bg d-flex align-items-center text-gray-90">
                <div class="col col-lg-6 col-xl-5 col-wd-6 mb-3 mb-lg-0 pr-lg-0">
                  <img class="img-fluid" src={promo1} alt="Image Description" />
                </div>
                <div class="col col-lg-6 col-xl-7 col-wd-6 pr-xl-4 pr-wd-3">
                  <div class="mb-2 pb-1 font-size-18 font-weight-light text-ls-n1 text-lh-23">
                    LOS MEJORES <strong>ACCESORIOS</strong> A UN TAP
                  </div>
                  {catTecno.map(category => (
                    <li
                      onClick={() => {
                        getProductsByCategory(
                          category.id,
                          category,
                          category.name,
                          paginate,
                          0,
                          0,
                          0,
                        )
                      }}
                    >
                      <Link
                        class="link text-gray-90 font-weight-bold font-size-15"
                        to={`/product_list/${category.name}`}
                      >
                        VER MÁS
                        <span class="link__icon ml-1">
                          <span class="link__icon-inner">
                            <i class="ec ec-arrow-right-categproes"></i>
                          </span>
                        </span>
                      </Link>
                    </li>
                  ))}
                </div>
              </Link>
            </li>
            <li class="px-2 px-xl-0 flex-shrink-0 flex-xl-shrink-1 mb-3">
              <Link class="min-height-126 max-width-320 py-1 py-xl-2 py-wd-1 banner-bg d-flex align-items-center text-gray-90">
                <div class="col col-lg-6 col-xl-5 col-wd-6 mb-3 mb-lg-0 pr-lg-0">
                  <img class="img-fluid" src={promo2} alt="Image Description" />
                </div>
                <div class="col col-lg-6 col-xl-7 col-wd-6 pr-xl-4 pr-wd-3">
                  <div class="mb-2 pb-1 font-size-18 font-weight-light text-ls-n1 text-lh-23">
                    DALE A TU MASCOTA <strong>LO QUE SE MERECE</strong>
                  </div>
                  {catMascotas.map(category => (
                    <li
                      onClick={() => {
                        getProductsByCategory(
                          category.id,
                          category,
                          category.name,
                          paginate,
                          0,
                          0,
                          0,
                        )
                      }}
                    >
                      <Link
                        class="link text-gray-90 font-weight-bold font-size-15"
                        to={`/product_list/${category.name}`}
                      >
                        VER MÁS
                        <span class="link__icon ml-1">
                          <span class="link__icon-inner">
                            <i class="ec ec-arrow-right-categproes"></i>
                          </span>
                        </span>
                      </Link>
                    </li>
                  ))}
                </div>
              </Link>
            </li>
            <li class="px-2 px-xl-0 flex-shrink-0 flex-xl-shrink-1 mb-0">
              <Link class="min-height-126 max-width-320 py-1 py-xl-2 py-wd-1 banner-bg d-flex align-items-center text-gray-90">
                <div class="col col-lg-6 col-xl-5 col-wd-6 mb-3 mb-lg-0 pr-lg-0">
                  <img class="img-fluid" src={promo3} alt="Image Description" />
                </div>
                <div class="col col-lg-6 col-xl-7 col-wd-6 pr-xl-4 pr-wd-3">
                  <div class="mb-2 pb-1 font-size-18 font-weight-light text-ls-n1 text-lh-23">
                    RENUEVA <strong>Y DECORA</strong> TU HOGAR
                  </div>
                  {catHogar.map(category => (
                    <li
                      onClick={() => {
                        getProductsByCategory(
                          category.id,
                          category,
                          category.name,
                          paginate,
                          0,
                          0,
                          0,
                        )
                      }}
                    >
                      <Link
                        class="link text-gray-90 font-weight-bold font-size-15"
                        to={`/product_list/${category.name}`}
                      >
                        VER MÁS
                        <span class="link__icon ml-1">
                          <span class="link__icon-inner">
                            <i class="ec ec-arrow-right-categproes"></i>
                          </span>
                        </span>
                      </Link>
                    </li>
                  ))}
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

